module.exports = __webpack_public_path__ + "frontend/images/devise-singup-c4a7fb640dccb2602561134ca71e7642.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/devise-singup.jpg
// module id = 333
// module chunks = 2